import { useEffect, useState } from "react";
import { dataDownload, dataFetch } from "../../utils/data-fetch";
import { useAuth } from "../../context/AuthContext";
import MakeFullScreen from "../MakeFullScreen";
import moment from "moment";
import {
  Box,
  Card,
  CircularProgress,
  Container,
  IconButton,
  Stack,
  TablePagination,
  Typography,
} from "@mui/material";
import Label from "../Label";
import { useSnackbar } from "src/context/SnackbarContext";
import {
  DownloadRounded,
  LocalShippingRounded,
  PaymentRounded,
} from "@mui/icons-material";

export const TransactionHistoryModal = ({ isOpen, onClose }) => {
  const getDateStringSync = (time) => {
    const utcOffset = 330 * 60 * 1000;
    const newTime = new Date(time + utcOffset);

    const st = moment(newTime).utc();
    const a = st.format("DD MMM YYYY");

    return a;
  };

  const [transactionHistory, setTransactionHistory] = useState(null);
  const [loading, setLoading] = useState(true);

  const { getAccessToken } = useAuth();
  const { showSnackbar } = useSnackbar();

  const [page, setPage] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const getTransactionHistory = async () => {
    setLoading(true);

    const url = `/api/extrasales/b2bact/txns/query?skip=${
      page * 5
    }&limit=5&sort=d`;

    const ret = await dataFetch(url, await getAccessToken());

    if (ret.success) {
      console.log("Transaction History", ret.data);
      setTransactionHistory(ret.data);
    } else {
      showSnackbar(ret.error || "Failed to fetch data", "error");
    }

    setLoading(false);
  };

  const downloadInvoice = async (txn) => {
    setLoading(true);

    let url = `/api/extrasales/b2bact/invoice/${txn._id}`;

    const ret = await dataDownload(url, await getAccessToken(), "bill.pdf");
    if (ret.success === true) {
      showSnackbar("Download complete", "success");
    } else {
      showSnackbar(ret.message || "Download failed", "error");
    }

    setLoading(false);
  };

  useEffect(() => {
    getTransactionHistory();
  }, [page]);

  return (
    <MakeFullScreen
      open={isOpen}
      onClose={onClose}
      title={"Transaction History"}
      fullScreen={true}
    >
      <Container sx={{ p: 1 }}>
        {loading === false ? (
          <Stack spacing={1}>
            {transactionHistory.map((txn, index) => (
              <Card key={txn._id} sx={{ p: 2, boxShadow: 2 }}>
                <Stack direction="column" justifyContent="center">
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Stack direction="row" alignItems="center" spacing={1}>
                      {txn?.category === "sale" ? (
                        <LocalShippingRounded color="error" fontSize="large" />
                      ) : (
                        <PaymentRounded color="primary" fontSize="large" />
                      )}

                      <Typography variant="subtitle1">
                        {getDateStringSync(txn?.date)}
                      </Typography>
                    </Stack>

                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: txn?.amount >= 0 ? "primay.main" : "error.main",
                      }}
                    >
                      ₹ {Math.abs(txn?.amount)?.toFixed(1)}
                    </Typography>
                  </Stack>

                  {txn?.category === "sale" &&
                    txn?.bill?.items?.map((item) => (
                      <Stack
                        direction="row"
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        key={item?.name}
                        mt={0.5}
                      >
                        <Typography variant="body2">
                          <b>{item?.name?.toUpperCase()}</b>
                        </Typography>
                        <Typography variant="body2">
                          {item?.quantity} KG @ ₹ {item?.rate}
                        </Typography>
                      </Stack>
                    ))}

                  {txn.comments && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      {txn?.comments}
                    </Typography>
                  )}

                  {txn?.category === "sale" && (
                    <Stack
                      direction={"row"}
                      spacing={1}
                      mt={1}
                      justifyContent={"flex-end"}
                    >
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => downloadInvoice(txn)}
                      >
                        <DownloadRounded />
                      </IconButton>
                    </Stack>
                  )}
                </Stack>
              </Card>
            ))}

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <TablePagination
                component="div"
                count={-1}
                rowsPerPage={5}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPageOptions={[5]}
              />
            </Box>
          </Stack>
        ) : (
          <Card sx={{ p: 3, boxShadow: 2, m: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 150,
              }}
            >
              <CircularProgress />
            </Box>
          </Card>
        )}
      </Container>
    </MakeFullScreen>
  );
};
